/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Tournament_Wiz_StepInputs */



/**
* | output |
* | --- |
* | "Question {current} of {total}" |
*
* @param {Tournament_Wiz_StepInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_step = /** @type {((inputs: Tournament_Wiz_StepInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_StepInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Question ${i?.current} sur ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pregunta ${i?.current} de ${i?.total}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Pergunta ${i?.current} de ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Domanda ${i?.current} di ${i?.total}`)
	return /** @type {LocalizedString} */ (`Question ${i?.current} of ${i?.total}`)
});